export const T = {
  en_GB: {
    titlePerson: "Power of Attorney / Guardian",
    titleCompany: "Representatives",
    titleGroup: "Representatives",
    description:
      "Persons authorized to act on behalf of this client — with the basis, scope and validity of their authority. Register two or more only when they act together: each of them then answers knowledge and experience for themselves.",
    descriptionGroup:
      "External representatives for the group. If none is registered, the members marked as representative on the Members tab act for the group. With two or more, each of them answers knowledge and experience for themselves.",
    addParty: "Add",
    capReached: (max: number) => `A client can have at most ${max} active representatives.`,
    editParty: "Edit",
    noParties: "No related parties registered.",
    noPartiesGroup:
      "No representative registered — add an external one here, or mark one or more members as representative on the Members tab.",
    groupFallbackBadge: "Group member",
    groupFallbackFor: (role: string, member: string) => `${role} for ${member}`,
    groupFallbackNote:
      "Acting representative — set via the Representative checkbox on the Members tab.",
    editGroupMember: "Edit member",
    dialogDescription: "Record who may act for the client and on what authority.",
    role: "Role",
    roleLabels: {
      representative: "Representative",
      poa: "Power of Attorney",
      guardian: "Guardian",
    } as Record<string, string>,
    name: "Name",
    ssn: "SSN",
    dateOfBirth: "Date of birth",
    email: "Email",
    phone: "Phone",
    country: "Country",
    selectCountry: "Select country…",
    authorityBasis: "Authority basis",
    basisLabels: {
      signatory: "Signatory rights",
      board_resolution: "Board resolution",
      poa: "Power of attorney",
      fremtidsfullmakt: "Future POA (fremtidsfullmakt)",
      vergemal: "Guardianship (vergemål)",
    } as Record<string, string>,
    selectBasis: "Select basis…",
    authorityScope: "Scope / mandate limits",
    scopePlaceholder: "e.g. investments up to 1 MNOK",
    validFrom: "Valid from",
    expiresAt: "Expires",
    notes: "Notes",
    cannotSignSimple: "Cannot sign with simple signature — no email or phone number.",
    cannotSignEid: "Cannot sign with eID — SSN missing, or country missing/unsupported.",
    clear: "Clear",
    signingLimited: "Missing details limit how this person can sign:",
    nameRequired: "Name is required",
    save: "Save",
    cancel: "Cancel",
    deleteParty: "Remove",
    deleteConfirmation: (name: string) => `Remove "${name}"?`,
    failedToSave: "Failed to save",
  },
  nb_NO: {
    titlePerson: "Fullmakt / verge",
    titleCompany: "Representanter",
    titleGroup: "Representanter",
    description:
      "Personer med fullmakt til å handle på vegne av denne kunden — med grunnlag, omfang og gyldighet for fullmakten. Registrer to eller flere bare når de handler sammen: hver av dem svarer da på kunnskap og erfaring for seg selv.",
    descriptionGroup:
      "Eksterne representanter for gruppen. Hvis ingen er registrert, representerer medlemmene som er markert som representant under Medlemmer-fanen gruppen. Med to eller flere svarer hver av dem på kunnskap og erfaring for seg selv.",
    addParty: "Legg til",
    capReached: (max: number) => `En klient kan ha høyst ${max} aktive representanter.`,
    editParty: "Rediger",
    noParties: "Ingen relaterte parter registrert.",
    noPartiesGroup:
      "Ingen representant registrert — legg til en ekstern her, eller marker ett eller flere medlemmer som representant under Medlemmer-fanen.",
    groupFallbackBadge: "Gruppemedlem",
    groupFallbackFor: (role: string, member: string) => `${role} for ${member}`,
    groupFallbackNote:
      "Fungerende representant — angitt via Representant-avkrysningen under Medlemmer-fanen.",
    editGroupMember: "Rediger medlem",
    dialogDescription: "Registrer hvem som kan handle for kunden og på hvilket grunnlag.",
    role: "Rolle",
    roleLabels: {
      representative: "Representant",
      poa: "Fullmektig",
      guardian: "Verge",
    } as Record<string, string>,
    name: "Navn",
    ssn: "Fødselsnummer",
    dateOfBirth: "Fødselsdato",
    email: "E-post",
    phone: "Telefon",
    country: "Land",
    selectCountry: "Velg land…",
    authorityBasis: "Fullmaktsgrunnlag",
    basisLabels: {
      signatory: "Signaturrett",
      board_resolution: "Styrevedtak",
      poa: "Fullmakt",
      fremtidsfullmakt: "Fremtidsfullmakt",
      vergemal: "Vergemål",
    } as Record<string, string>,
    selectBasis: "Velg grunnlag…",
    authorityScope: "Omfang / mandatgrenser",
    scopePlaceholder: "f.eks. investeringer inntil 1 MNOK",
    validFrom: "Gyldig fra",
    expiresAt: "Utløper",
    notes: "Notater",
    cannotSignSimple: "Kan ikke signere med enkel signatur — mangler e-post og telefonnummer.",
    cannotSignEid:
      "Kan ikke signere med eID — fødselsnummer mangler, eller land mangler/støttes ikke.",
    clear: "Fjern",
    signingLimited: "Manglende opplysninger begrenser hvordan denne personen kan signere:",
    nameRequired: "Navn er påkrevd",
    save: "Lagre",
    cancel: "Avbryt",
    deleteParty: "Fjern",
    deleteConfirmation: (name: string) => `Fjerne "${name}"?`,
    failedToSave: "Kunne ikke lagre",
  },
} as const;
